<template lang="pug">
  button.wt-icon-button(type="button")
    slot
</template>

<script>
export default {
  name: "WtIconButton"
};
</script>

<style lang="sass" scoped>
.wt-icon-button
  border: none
  background: unset
  &:hover
    opacity: 0.6
</style>
